import { gql } from '@apollo/client';

const messagingContactsLookup = gql`query MessagingContactsLookup($searchTerm: String) {
	directMessages {
		recipientLookup(searchTerm: $searchTerm) {
			userId
			firstname
			lastname
			username
			avatarUrl
			requireApproval
		}
	}
}
`;
export default messagingContactsLookup;
